export const ROLE = {
  creator: 'creator',
  beneficiary: 'beneficiary',
};

export const defaultRequirements = [
  'NO movement or noise in your background!',
  'Sit facing daylight, not with it behind you.',
  // 'NO noise in your background!',
  "Don't touch your face.",
  'Good lighting is essential!',
  // 'Head and upper body in clear focus.',
  // "Your clothes don't blend in with your background.",
  // 'Whatever is inside the white dotted rectangle will be the visual of you and your digital twin forever! Make sure you are happy with how you look and your background.',
];

export const talkTimeOptTemplate = [
  { label: '1 hour <$talktime_1>', value: 'talktime-1hour' },
  { label: '5 hours <$talktime_5> (5% Off)', value: 'talktime-5hours' },
  { label: '10 hours <$talktime_10> (8% Off)', value: 'talktime-10hours' },
  { label: '25 hours <$talktime_25> (10% Off)', value: 'talktime-25hours' },
];

export const storageOptTemplate = [
  { label: '20GB <$storage_20> per month', value: 'storage-20GB' },
  { label: '50GB <$storage_50> per month', value: 'storage-50GB' },
  { label: '100GB <$storage_100> per month', value: 'storage-100GB' },
];

export const landscapeUserHorizontal = 'For the best recording experience, please turn off auto-rotate.';

export const resolutions = [
  // { width: 3840, height: 2160 }, // 4K UHD, 16:9
  // { width: 2160, height: 3840 }, // 4K UHD, 9:16
  // { width: 2560, height: 1440 }, // 1440p QHD, 16:9
  // { width: 1440, height: 2560 }, // 1440p QHD, 9:16
  { width: 1920, height: 1080 }, // 1080p FHD, 16:9
  { width: 1080, height: 1920 }, // 1080p FHD, 9:16
  { width: 1280, height: 720 }, // 720p HD, 16:9
  { width: 720, height: 1280 }, // 720p HD, 9:16
];

export const ShareStatus = {
  notShared: 0,
  shared: 1,
  resentLink: 2,
  accepted_logedin: 3,
};

// Temporary exchange rates — need to replace with an API call to fetch exact pricing for each region/country
export const exchangeRates: Record<string, number> = {
  // INR: 86.49,
  EUR: 0.85,
  GBP: 0.74,
  // JPY: 147.88,
  USD: 1,
};

//In USD
export const pricesUSD = {
  addbeneficiary: 99,
  talktime_1: 25,
  talktime_5: 118,
  talktime_10: 229,
  talktime_25: 562,
  storage_20: 4.99,
  storage_50: 9.99,
  storage_100: 14.99,
};
